import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IProject } from 'src/app/Models/interfaces/IProject';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.css']
})
export class SummaryComponent {

  @Input() project: IProject;
  @Input() index: number;
  @Output() ViewDetailsEvent = new EventEmitter<number>();

  viewDetails(detailsId: number) {
    this.ViewDetailsEvent.emit(detailsId);
  }


}
